import { render, staticRenderFns } from "./ComboBoostBanner.vue?vue&type=template&id=51e5c6e4&scoped=true&"
import script from "./ComboBoostBanner.vue?vue&type=script&lang=js&"
export * from "./ComboBoostBanner.vue?vue&type=script&lang=js&"
import style0 from "./ComboBoostBanner.vue?vue&type=style&index=0&id=51e5c6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5c6e4",
  null
  
)

export default component.exports